import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { resolveTextWithHTML } from '../../helpers/util';
import { MainModal } from '..';
import { Button } from '../styled';
import { modalActions } from '../../store/ducks/modal';
import { NoB2cDiv } from '../styled/Modal';

interface OwnProps {
  intl?: any;
}

const mapStateToProps = (state: any) => ({
  noSubscriptionModal: state.modalData.noSubscriptionModal,
});
type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  toggleNoSubscriptionModal: (isOpen: boolean) => void;
}
type Props = StateProps & DispatchProps & OwnProps;
class NoSubscriptionModal extends React.Component<Props> {
  handleClose = () => {
    this.props.toggleNoSubscriptionModal(false);
  }

  render() {
    return (
      <MainModal contentLabel="No Subscription Modal"
        isOpen={this.props.noSubscriptionModal} close={this.handleClose} >
        <NoB2cDiv>{ this.props.intl.formatMessage({ id: 'text_no_b2c' }) }</NoB2cDiv>
        <NoB2cDiv>{ resolveTextWithHTML(this.props.intl.formatMessage({ id: 'link_no_b2c_text' })) }</NoB2cDiv>
        <NoB2cDiv>{ resolveTextWithHTML(this.props.intl.formatMessage({ id: 'note_no_b2c' })) }</NoB2cDiv>
        <Button onClick={this.handleClose}><FormattedMessage id="ok" /></Button>
      </MainModal>
    );
  }
}

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, modalActions)(injectIntl(injectedIntl));

export function injectedIntl(props: Props) {
  return <NoSubscriptionModal {...props} />;
}
